// console.cclog('ℹ️ Initializing GfEntryTermField')

export default function initGfEntryTerm() {

  // console.cclog('ℹ️ initGfEntryTerm')
  window.GfEntryTermField = class GfEntryTermField {

    static yearsToBuildOut = parseInt(gfEntryTermFieldSettings.yearsToBuildOut)

    #selectElement
    
    // This instance's hidden input element
    #hiddenInput

    constructor(fieldId){

      // console.cclog('ℹ️ Initializing GfEntryTermField for #' + fieldId)

      this.#selectElement = document.getElementById(fieldId)
      this.#hiddenInput = document.getElementById(fieldId + '_hidden')

      // Make sure we found the right element for this POI field
      if(this.#selectElement && this.#hiddenInput){

        // console.cclog('ℹ️ Found select element #' + this.#selectElement.id + ' and hidden input #' + this.#hiddenInput.id)

        // Update hidden input when select element changes
        this.#selectElement.addEventListener('change', () => {
          this.#hiddenInput.value = this.#selectElement.value;
        });

        // We don't need to hide the field so populate it's options
        // based on the constructor args provided
        this.populate()
        
      } else {

        // console.cclog('❌ ERROR: GfEntryTermField could not find field by ID attribute #' + fieldId)
      }
    }


    // Populates options within select field when called with 
    // program data of this.#type
    populate() {

      // console.cclog('ℹ️ Populating GfEntryTermField for #' + this.#selectElement.id)
      
      this.#selectElement.disabled = true
  
      // Clear options if needed
      for (const option of this.#selectElement.options) {
        option.remove()
      }

      // Ensure a visitor has to make a choice
      const placeholder = document.createElement("option");
      placeholder.value = ""; // The value is empty
      placeholder.text = "Select an Entry Term...";
      placeholder.selected = true; // Makes it the default
      placeholder.disabled = true; // Prevents user from re-selecting it
      this.#selectElement.appendChild(placeholder);

      /**
       * Function to dynamically build out entry terms so we don't need to update them
       * every year. It uses datatel compatible field values to ease the import process
       *
       */
      
      const enrollmentPeriods = [{
          label: 'Spring',
          datatel_label: 'SP',
          //cut_off: 'January 4th'
          cut_off: '01/04',
          month: 'January'
      },{
          label: 'Fall',
          datatel_label: 'FA',
          // cut_off: 'August 24th'
          cut_off: '08/24',
          month: 'August'
      }]

      // set our dates up
      let currentDate = new Date(),
          lastDate = new Date(),
          now = new Date()

      // Set the last year we will build to
      lastDate.setFullYear(lastDate.getFullYear() + GfEntryTermField.yearsToBuildOut)

      // Now start building out our years
      do {
          const currentYear = currentDate.getFullYear()
          
          let optgroup = document.createElement("optgroup")
          optgroup.label = currentYear

          // Loop through our enrollment periods
          for(let i = 0; i < enrollmentPeriods.length; i++) {

              // Ensure the enrollment period for this year hasn't passed
              let cutOffDate = new Date(currentYear + '/' + enrollmentPeriods[i].cut_off)

              // If the cutoff date is in the future, add this option to our list
              if(now < cutOffDate) {
                  let option = document.createElement("option")

                  option.text = enrollmentPeriods[i].label + ' ' + currentYear + ' (' + enrollmentPeriods[i].month + ')'
                  option.value = currentYear + enrollmentPeriods[i].datatel_label
          
                  optgroup.appendChild(option)
              }
          }

          if(optgroup.children.length) this.#selectElement.appendChild(optgroup)

          currentDate.setFullYear(currentDate.getFullYear() + 1)

      } while(currentDate < lastDate)

      this.#selectElement.disabled = false
      
      // Check if there's a value in the hidden input
      if (this.#hiddenInput.value) {
        // console.cclog('ℹ️ Setting select element value to ' + this.#hiddenInput.value)
        this.#selectElement.value = this.#hiddenInput.value;
      }
    }
  }

  // Run after Gravity Forms and the multiple form instances plugin finish rendering/updating IDs
  jQuery(document).on('gform_post_render', function() {
    // console.cclog('ℹ️ gform_post_render for gf-entry-term.js')
    initializeEntryTermFields();
  });
  
  function initializeEntryTermFields() {
    // console.cclog('ℹ️ initializeEntryTermFields for gf-entry-term.js')
    // Find all selects that look like entry term fields
    document.querySelectorAll('.gfield--type-entry_term .gfield_select').forEach(select => {
      // console.cclog('ℹ️ Found select element #' + select.id)
      // Avoid double-initializing (optional: add a data attribute after init)
      if (!select.dataset.gfEntryTermInitialized) {
        new window.GfEntryTermField(select.id);
        select.dataset.gfEntryTermInitialized = 'true';
      }
    });
    // console.cclog('All entry term select fields:', document.querySelectorAll('.gfield--type-entry_term .gfield_select'));
  }

}